import React from "react";
import VisionMissionAimSection from "../Components/HomePageComponents/VisionMissionAimSection";
import HeroSection from "../Components/HomePageComponents/HeroSection";
import CorePrinciples from "../Components/HomePageComponents/CorePrinciples";
import ServicesSection from "../Components/HomePageComponents/ServicesSection";

import SupportFunctions from "../Components/HomePageComponents/SupportFunctions";
import EventsSection from "../Components/HomePageComponents/EventsSection";
import NewsInsights from "../Components/HomePageComponents/NewsInsights";
import YTVideos from "../Components/HomePageComponents/YTVideos";

const HomePage = () => {
  return (
    <div className="min-h-screen ">
      <HeroSection />
      <VisionMissionAimSection />
      <CorePrinciples />
      <ServicesSection />
      {/* <AdvisoryCouncilsSection /> */}
      <SupportFunctions />
      {/* <EventsSection /> */}
      {/* <NewsInsights /> */}
      <YTVideos />
    </div>
  );
};

export default HomePage;
